import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StateInterface } from "../store/state";
import loadButton from "../domains/3cx/loadButton";

const c3xStore = namespace("c3x");
const authStore = namespace("auth");

@Component
export default class ButtonLoader extends Vue {
  @c3xStore.Mutation private loaded!: () => void;

  @c3xStore.State((state: StateInterface): boolean => state.loaded)
  private isLoaded!: boolean;
  @authStore.Getter
  private loggedIn!: boolean;

  private check(): void {
    if (this.isLoaded || !this.loggedIn) return;
    loadButton();
    this.loaded();
  }

  @Watch("loggedIn")
  private onLoggedIn(): void {
    this.check();
  }

  private mounted(): void {
    this.check();
  }
}
